import {ComponentStore} from "@ngrx/component-store";
import {Serializer, Serializers} from "../../../interfaces/serializer";
import {Site} from "../../../interfaces/site";
import {Observable, withLatestFrom} from "rxjs";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store/store";
import {selectSite, selectSites} from "../../../store/init/init.selectors";
import {tap} from "rxjs/operators";
import {Router} from "@angular/router";
import {initSite} from "../../../store/init/init.actions";
import {Injectable} from "@angular/core";
import {dialogOpen} from "../../../store/dialog/dialog.actions";
import {IframeDialogComponent} from "../../../../settings/data-sources/data-sources-listing/iframe-dialog/iframe-dialog.component";
import {DataSource} from "../../../interfaces/data-source";
import {NotificationComponentObject} from "../../../classes/notification-component-object";
import {NotificationStore} from "../notification.store";

@Injectable()
export class NotificationTrackingUrlsTemplateStore extends ComponentStore<any> {

  public readonly onAddTrackingClick = this.effect((params$: Observable<{ site: Serializer<Site>, data_source: Serializer<DataSource>, data_set_usage: Serializer<DataSource>, notification: NotificationComponentObject }>): Observable<[{ site: Serializer<Site>, data_source: Serializer<DataSource>, data_set_usage: Serializer<DataSource>, notification: NotificationComponentObject }, Serializers<Site>, Serializer<Site>]> => params$.pipe(
    withLatestFrom(this._store.select(selectSites), this._store.select(selectSite)),
    tap(([params, sites, current]: [{ site: Serializer<Site>, data_source: Serializer<DataSource>, data_set_usage: Serializer<DataSource>, notification: NotificationComponentObject }, Serializers<Site>, Serializer<Site>]): void => {
      if (current.id != params.site.id) {
        this._store.dispatch(initSite({site: sites.find((item: Serializer<Site>): boolean => item.id === params.site.id)}));
      }

      this._router.navigate([`/${params.site.id}/data-sources/list`]);
      this._store.dispatch(dialogOpen({
        component: IframeDialogComponent,
        data: {
          inputData: {
            link: params.site.id + '/data-sources/' + params.data_source.id + '/' + params.data_set_usage.id + '/tracking_urls'
          }
        },
        config: {
          width: '800px',
          height: '600px'
        },
        disableClose: false
      }));

      this._notificationStore.markAsRead({ notification: params.notification, closeMenu: true });
    })
  ));

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _router: Router,
    private readonly _notificationStore: NotificationStore
  ) {
    super({});
  }
}

